import { DamoAuthEnvironment } from './damoauth.environment';
import packageInfo from '../../../../package.json';

export const environment: DamoAuthEnvironment = {
  name: 'staging',
  firebase: {
    apiKey: 'AIzaSyCh8SNbH4fvvQf7J3ntG2tZzhc2Mzsr5n8',
    authDomain: 'staging-damotech-platform.firebaseapp.com',
    databaseURL: 'https://staging-damotech-platform.firebaseio.com',
    projectId: 'staging-damotech-platform',
    storageBucket: 'staging-damotech-platform.appspot.com',
    messagingSenderId: '1055918849476',
    appId: '1:1055918849476:web:83f0a27692a54656',
    measurementId: 'G-9NW8M8WDH2',
  },
  fns: 'https://platform-staging.2totems.com/api',
  fnsOrigin: 'https://staging-damoauth.web.app',
  domain: '.2totems.com',
  postLoginRedirectUrl: 'https://platform-staging.2totems.com',
  target: 'hosting',
  sentry: {
    dsn: 'https://d50f63dd5efb868d3af5d08fb69c1571@o509349.ingest.us.sentry.io/4511469465829376',
    release: `damoauth@${packageInfo.version}`,
  },
};
